/* HÖNGRY cadeaus in het mandje (RK Creative Solutions). Zie snippets/hongry-gifts.liquid voor uitleg. */
(function () {
  if (window.__hgGiftsLoaded) return;
  window.__hgGiftsLoaded = true;

  var cfgEl = document.getElementById('hg-gift-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var PROP = '_hongry_gift';
  var STORE_KEY = 'hg_gift_choice';
  var TEXT = {
    card: { title: 'Kies je wenskaart', pick: 'Kies een kaart', ok: 'Deze kaart wil ik' },
    poster: { title: 'Kies je poster', pick: 'Kies een poster', ok: 'Deze poster wil ik' }
  };

  var busy = false;
  var again = false;
  var failed = {};
  var changeLog = [];
  var lastCart = null;
  var sheetKind = null;
  var sheetSel = null;

  function loadChoice() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function saveChoice(kind, id) {
    try { var c = loadChoice(); c[kind] = id; localStorage.setItem(STORE_KEY, JSON.stringify(c)); } catch (e) {}
  }
  function validId(kind, id) {
    if (!id) return false;
    return (CFG[kind] || []).some(function (o) { return o.id === id; });
  }

  function allowChange() {
    var now = Date.now();
    changeLog = changeLog.filter(function (t) { return now - t < 60000; });
    if (changeLog.length >= 12) return false;
    changeLog.push(now);
    return true;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('post');
      return r.json();
    });
  }

  function paidTotal(cart) {
    return cart.items.reduce(function (sum, it) {
      return it.properties && it.properties[PROP] ? sum : sum + it.final_line_price;
    }, 0);
  }
  function giftLines(cart) {
    var out = {};
    cart.items.forEach(function (it) {
      var k = it.properties && it.properties[PROP];
      if (k && !out[k]) out[k] = it;
    });
    return out;
  }

  function pendingKinds(cart) {
    if (!cart) return [];
    var paid = paidTotal(cart);
    var lines = giftLines(cart);
    var p = [];
    if (paid >= CFG.thresholds.card && !lines.card && CFG.card.length) p.push('card');
    if (paid >= CFG.thresholds.poster && !lines.poster && CFG.poster.length) p.push('poster');
    return p;
  }

  function addGift(kind, id) {
    if (failed[id]) return Promise.resolve(false);
    var props = {};
    props[PROP] = kind;
    return post('/cart/add.js', { items: [{ id: id, quantity: 1, properties: props }] })
      .then(function () { return true; })
      .catch(function () { failed[id] = true; return false; });
  }
  function setLine(key, qty) {
    return post('/cart/change.js', { id: key, quantity: qty }).then(function () { return true; }).catch(function () { return false; });
  }

  function plan(cart) {
      var paid = paidTotal(cart);
      var choice = loadChoice();
      var kept = {};
      var jobs = [];

      cart.items.forEach(function (it) {
        var k = it.properties && it.properties[PROP];
        if (!k) return;
        var ok = CFG.thresholds[k] !== undefined && paid >= CFG.thresholds[k] && !kept[k];
        if (ok && k === 'book') ok = it.variant_id === CFG.book;
        if (ok && k !== 'book') ok = validId(k, it.variant_id);
        if (!ok) {
          jobs.push(function () { return setLine(it.key, 0); });
          return;
        }
        kept[k] = true;
        if (it.quantity !== 1) jobs.push(function () { return setLine(it.key, 1); });
      });

      if (!kept.book && CFG.book && !failed[CFG.book] && paid >= CFG.thresholds.book) {
        jobs.push(function () { return addGift('book', CFG.book); });
      }
      ['card', 'poster'].forEach(function (k) {
        if (!kept[k] && paid >= CFG.thresholds[k] && validId(k, choice[k]) && !failed[choice[k]]) {
          jobs.push(function () { return addGift(k, choice[k]); });
        }
      });

      return jobs;
  }

  /* Eén aanpassing per keer: Shopify geeft regels een nieuwe sleutel als kortingen veranderen,
     dus na elke stap lezen we het mandje opnieuw in. Maximaal 6 stappen per ronde. */
  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    var changed = false;
    var steps = 0;
    function step() {
      return getCart().then(function (cart) {
        lastCart = cart;
        var jobs = plan(cart);
        if (!jobs.length || steps >= 6 || !allowChange()) return;
        steps++;
        return jobs[0]().then(function () { changed = true; return step(); });
      });
    }
    step().then(function () {
      if (!changed) return;
      return getCart().then(function (c) { lastCart = c; refresh(); });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; setTimeout(reconcile, 300); }
    });
  }

  /* Ververs het hele zijpaneel (ook de lege toestand) en het bolletje in de header,
     en laat andere onderdelen (zoals de winkelmandpagina) weten dat het mandje veranderde. */
  function refresh() {
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (s) {
        var parser = new DOMParser();
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && s['cart-drawer']) {
          var src = parser.parseFromString(s['cart-drawer'], 'text/html');
          var inner = src.querySelector('#CartDrawer');
          var target = document.getElementById('CartDrawer');
          if (inner && target) {
            target.innerHTML = inner.innerHTML;
            var srcDrawer = src.querySelector('cart-drawer');
            drawerEl.classList.toggle('is-empty', !!(srcDrawer && srcDrawer.classList.contains('is-empty')));
            var overlay = target.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof drawerEl.close === 'function') overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {})
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hongry-gifts' });
        }
      });
  }

  var root = document.getElementById('hg-gifts');
  var grid = document.getElementById('hg-grid');
  var confirmBtn = document.getElementById('hg-confirm');
  var msg = document.getElementById('hg-msg');
  var titleEl = document.getElementById('hg-sheet-title');
  var lastFocus = null;
  var chk = '<span class="hg-chk" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3.2 3L13 4.5" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function openSheet(kind) {
    if (!TEXT[kind]) return;
    sheetKind = kind;
    var lines = lastCart ? giftLines(lastCart) : {};
    sheetSel = lines[kind] ? lines[kind].variant_id : (loadChoice()[kind] || null);
    if (!validId(kind, sheetSel)) sheetSel = null;
    titleEl.textContent = TEXT[kind].title;
    msg.textContent = '';
    grid.innerHTML = CFG[kind].map(function (o) {
      var sel = o.id === sheetSel;
      return '<button type="button" role="radio" class="hg-opt' + (sel ? ' is-sel' : '') + '" aria-checked="' + sel + '" data-id="' + o.id + '">' + chk +
        '<img src="' + esc(o.img) + '" alt="" loading="lazy"><span>' + esc(o.title) + '</span></button>';
    }).join('');
    setConfirm();
    lastFocus = document.activeElement;
    root.classList.add('hg-open');
    setTimeout(function () { var f = grid.querySelector('.is-sel') || grid.querySelector('.hg-opt'); if (f) f.focus(); }, 50);
  }
  function closeSheet() {
    root.classList.remove('hg-open');
    sheetKind = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function setConfirm() {
    confirmBtn.disabled = sheetSel === null;
    confirmBtn.textContent = sheetSel === null ? TEXT[sheetKind].pick : TEXT[sheetKind].ok;
  }

  grid.addEventListener('click', function (e) {
    var b = e.target.closest('.hg-opt');
    if (!b) return;
    sheetSel = parseInt(b.dataset.id, 10);
    grid.querySelectorAll('.hg-opt').forEach(function (o) {
      var s = parseInt(o.dataset.id, 10) === sheetSel;
      o.classList.toggle('is-sel', s);
      o.setAttribute('aria-checked', s);
    });
    setConfirm();
  });

  confirmBtn.addEventListener('click', function () {
    if (sheetSel === null || !sheetKind) return;
    var kind = sheetKind;
    var id = sheetSel;
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Even geduld...';
    saveChoice(kind, id);
    delete failed[id];
    getCart().then(function (cart) {
      var line = giftLines(cart)[kind];
      if (line && line.variant_id === id) return true;
      var step = line ? setLine(line.key, 0) : Promise.resolve(true);
      return step.then(function () { return addGift(kind, id); });
    }).then(function (ok) {
      if (!ok) {
        msg.textContent = 'Dit cadeau lukte even niet. Kies een ander of probeer het zo opnieuw.';
        setConfirm();
        return;
      }
      closeSheet();
      return getCart().then(function (c) { lastCart = c; refresh(); });
    }).catch(function () {
      msg.textContent = 'Je mandje werd even niet bijgewerkt. Probeer het zo opnieuw.';
      setConfirm();
    });
  });

  root.addEventListener('click', function (e) { if (e.target.closest('[data-hg-close]')) closeSheet(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('hg-open')) closeSheet(); });

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-hg-pick]');
    if (pick) {
      e.preventDefault();
      openSheet(pick.getAttribute('data-hg-pick'));
      return;
    }
    var checkout = e.target.closest('#CartDrawer-Checkout, button[name="checkout"]');
    if (checkout) {
      var pend = pendingKinds(lastCart);
      if (pend.length) {
        e.preventDefault();
        e.stopPropagation();
        openSheet(pend[0]);
        msg.textContent = pend[0] === 'card' ? 'Kies eerst je gratis wenskaart.' : 'Kies eerst je gratis poster.';
      }
    }
  }, true);

  function start() {
    reconcile();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'hongry-gifts') {
          getCart().then(function (c) { lastCart = c; }).catch(function () {});
          return;
        }
        setTimeout(reconcile, 250);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();